import LDClient from 'launchdarkly-js-client-sdk';
import envConfig from '../../static/config';

let ldClient = null;

const getLDContext = () => {
  const rootDomain = window.location.hostname.split('.')[0];
  return {
    kind: 'multi',
    application: {
      key: rootDomain,
      project: 'Internet Banking',
      platform: 'Web',
    },
  };
};

export const initLaunchDarkly = () => {
  try {
    if (ldClient !== null) {
      return ldClient;
    }
    const ldContext = getLDContext();
    ldClient = LDClient.initialize(
      envConfig.launchDarklyClientSideId,
      ldContext
    );
    return ldClient;
  } catch (error) {
    console.error(error);
  }
};

const checkIsLaunchDarklyReady = async () => {
  if (!ldClient) {
    console.error('LaunchDarkly client is not initialized.');
    return false;
  }
  try {
    await ldClient.waitUntilReady();
    return true;
  } catch (error) {
    console.error('Error waiting for LaunchDarkly readiness:', error);
    return false;
  }
};

export const getLaunchDarklyFlag = async (flagName, defaultFlagValue) => {
  const isLDready = await checkIsLaunchDarklyReady();
  if (!isLDready) {
    return defaultFlagValue;
  }
  try {
    const flagValue = ldClient.variation(flagName, defaultFlagValue);
    return flagValue;
  } catch (error) {
    console.error(`Error getting flag:`, error);
    return defaultFlagValue;
  }
};
